// angular
import {Injectable, inject, signal} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
// services
import {StorageService} from "./storage.service";
// types
import {environment} from "src/environments/environment";
import {IEmploysPeople} from "@app/+messaging/shared/interfaces/member.interface";

@Injectable()
export class EmployeeService {
  public employeesData = signal<IEmploysPeople[]>([]);

  // dependencies
  private _httpClient = inject(HttpClient);
  private _storageService = inject(StorageService);

  constructor() {}

  public getClientGroups() {
    return this._httpClient.get<{data: {name: string; id: string}[]}>(
      `groups/client/${environment.auth.clientUniqueId}`
    );
  }

  private _getEmployees(id: string) {
    return this._httpClient.get<{data: IEmploysPeople[]}>(
      `profiles/get-by-groups/${id}`
    );
  }

  public getEmployees(): Observable<IEmploysPeople[]> {
    return new Observable((subscriber) => {
      this.getClientGroups().subscribe({
        next: (res) => {
          // searching for MEAT_EMPLOYEE and MEAT_[ACTIVE_BRANCH]
          const isfahanGroup = res.data.find((group) =>
            group.name.includes(this._storageService.getBranch())
          )?.id;
          const employeeGroup = res.data.find((group) =>
            group.name.includes("EMPLOYEE")
          )?.id;
          if (isfahanGroup && employeeGroup) {
            this._getEmployees(isfahanGroup + "+" + employeeGroup).subscribe({
              next: (res) => {
                this.employeesData.set(res.data);

                subscriber.next(res.data);
                subscriber.complete();
              },
              error: () => {},
            });
          }
        },
        error: () => {},
      });
    });
  }
}
